import React from 'react';

function ComponentOverlay({ component }) {
  if (!component) return null;

  return (
    <div className="component-overlay">
      <div className="overlay-content">
        <h4 className="overlay-title">{component.name}</h4>
        <p className="overlay-manufacturer">{component.manufacturer}</p>
      </div>
    </div>
  );
}

export default ComponentOverlay;
